import gql from "graphql-tag";

export function generate_FETCH_PRE_ORDER_TRIPS(name, type = 'query') {
return gql`
 ${type} ${name}($startDate:timestamptz!, $endDate:timestamptz!, $status:[uuid!], $organizationId:uuid!, $route:uuid, $type:String, $search:String, $offset: Int!, $limit: Int!, $orderBy: [VehicleTrip_order_by!]){
 ${name}: VehicleTrip(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { statusId: {_in: $status}}, { routeId: {_eq: $route}}, { type: {_eq: $type}}, { organizationId: {_eq: $organizationId}},  
     {_or:[{tripId:{_ilike:$search}}, {Route: {name: {_ilike:$search}}} ]} ]}, offset: $offset, limit: $limit, order_by: $orderBy ){
  id
  tripId
  statusId
  TripStatus {id title}
  Route {id name}     
  CreatedBy {id name}
  totalShops: TripDestinations_aggregate {aggregate{count}}     
  visitedShops: TripDestinations_aggregate(where: {status: {_eq: "VISITED"}}) {aggregate{count}}     
  created_at         
  updated_at
  dispatched_at          
  delivered_at
  started_at
  completed_at
  }
 }`
}

export function generate_SUBSCRIBE_PRE_ORDER_TRIPS_COUNT(name) {
 return gql`
  subscription ${name}($startDate:timestamptz!, $endDate:timestamptz!, $status:[uuid!], $organizationId:uuid!, $route:uuid, $type:String, $search:String){
   ${name}: VehicleTrip_aggregate(where:{_and:[ { created_at: {_gte: $startDate}},{ created_at: {_lte: $endDate}}, { statusId: {_in: $status}}, { routeId: {_eq: $route}}, { type: {_eq: $type}}, { organizationId: {_eq: $organizationId}},
        {_or:[{tripId:{_ilike:$search}}, {Route: {name: {_ilike:$search}}}]} ]} ){
    aggregate { count }                
   }
}`
}

export const SUBSCRIBE_PRE_ORDER_TRIP_DETAILS_BY_ID = gql`
    subscription ($id: uuid){
        Trips: VehicleTrip(where: {id: {_eq: $id}}){
            id
            tripId
            statusId            
            created_at
            updated_at
            TripStatus {id title}
            Route{id name}
            Vehicle{id name}
            Driver{id name}
            Order_aggregate {aggregate {count sum{ finalPrice }}}
            Order{id OrderItems{id quantity productId unitId Product{id displayName price bunchPrice noOfPieceInBox retailer weight colorCode packageType containerType image bunchKg} }}
            CreditDebit_aggregate {aggregate {sum {orderAmount amount}} }
            Expense {
                id
                amount
                note
                created_at
                Expenses{
                    id
                    title
                }
                ExpenseAttachments{
                    id
                    image
                }
            }
            GPSTracking(limit:1, order_by: {created_at: desc}){
                id
                lat
                long
            }
            VehicleTripStock(order_by: {Unit: {unit: asc}}){
                id
                initialQty
                currentQty
                unloadedQty
                productId
                unitId
                Product{
                    id
                    displayName
                    price
                    bunchPrice
                    retailer
                    weight
                    colorCode
                    packageType
                    image
                    bunchKg
                }
                Unit{
                    id
                    unit
                }
            }
            OrganizationStock{
                id
                quantity
                productId
                unitId
                organizationId
            }
            TripDestinations(order_by: {checkInTime: asc_nulls_last}){
                id
                shopId
                shopName
                checkInTime
                checkOutTime
                lastVisitedDate
                notes
                status
                timeSpent
                Order{
                    id
                    price
                    finalPrice
                    colloectedAmount
                }
            }
            CreatedBy{
              id
              name
            }
        }
    }`